module.exports = __webpack_public_path__ + "img/安益集團_Logo_4.d500860d.svg";